<template>
    <div style="max-width: 550px;" class="d-flex w-100 flex-column align-center">
        <div
            :style="smallLogo ? 'max-width: 150px; transform: translateY(28px)' : 'max-width: 200px; transform: translateY(28px)'"
            class="w-100"

        >
            <div class="pa-3 purple lighten-1 rounded-circle">
                <div class="white rounded-circle pa-6">
                    <v-img
                        contain
                        aspect-ratio="1"
                        src="@/assets/uku-logo-colored.svg"
                    />
                </div>
            </div>
        </div>
        <v-card
            style="border: 1px dashed var(--v-n5-base); border-radius: 24px; "
            :style="$vuetify.breakpoint.smAndUp ? 'padding-left: 80px; padding-right: 80px' : 'padding-left: 24px; padding-right: 24px'"
            class="w-100 py-6 pb-10"
        >
            <slot />
        </v-card>
    </div>
</template>

<script>
export default {
    name: "MainCard",
    components: {
    },
    props: {
        smallLogo: {
            type: Boolean,
            default: false
        }
    }
};
</script>
